export default __webpack_public_path__ + "static/media/headset14.e61cd4aa.jfif";